import React, { useState, useEffect } from 'react'
import { Panel, Table } from 'rsuite'
import { cloneDeep } from 'lodash-es'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ReactECharts from 'echarts-for-react'
import { CHART_THEME } from '../../constants/project'

export default function ChartBudgetApproved5Year() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [chartOption, setChartOption] = useState()

  useEffect(() => {
    handelGetSchema()
  }, [])

  const handelGetSchema = async () => {
    setIsLoading(true)
    try {
      // const response = await getUserProfile()
      const response = mockShema
      let chartOp = cloneDeep(chartSchema)

      let series = []

      response?.datas?.forEach((item, index) => {
        let s = cloneDeep(chartSerie)
        s.name = item.name
        s.data = item.value || []
        s.stack = index == 0 ? 'one' : 'two'

        series.push(s)
      })

      chartOp.xAxis.data = response?.category || []
      chartOp.series = series

      setChartOption(chartOp)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <Panel
      header={schema.header || 'งบอนุมัติย้อนหลัง 5 ปี'}
      bordered
      shaded
      collapsible
      defaultExpanded
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <ReactECharts
        theme={CHART_THEME}
        option={chartOption}
        style={{ minHeight: '400px', width: '100%' }}
        className={'react_for_echarts'}
      />
    </Panel>
  )
}
const mockShema = {
  header: 'งบอนุมัติย้อนหลัง 5 ปี',
  // category: ['งบอนุมัติ(ล้านบาท)', 'เบิกจ่ายโครงการใหม่(ล้านบาท)', 'เบิกจ่ายต่อเนื่ง(ล้านบาท)'],
  category: ['2563', '2564', '2565', '2566', '2567'],
  datas: [
    { name: 'งบอนุมัติ', value: [3100, 4100, 5100, 6000, 6500] },
    { name: 'เบิกจ่ายโครงการใหม่', value: [2100, 3100, 3500, 4100, 3500] },
    { name: 'เบิกจ่ายต่อเนื่อง', value: [1000, 1000, 1200, 1100, 2100] },
  ],
}
const emphasisStyle = {
  itemStyle: {
    shadowBlur: 10,
    shadowColor: 'rgba(0,0,0,0.3)',
  },
}

const chartSerie = {
  name: '',
  type: 'bar',
  stack: '',
  emphasis: emphasisStyle,
  data: [],
}

const chartSchema = {
  title: {
    text: '',
  },
  legend: {
    data: [],
    left: '10%',
  },
  toolbox: {
    show: true,
    bottom: '10',
    feature: {
      magicType: {
        type: ['stack'],
      },
      restore: { show: true },
      saveAsImage: { show: true, title: 'บันทึกเป็นรูป' },
    },
  },
  tooltip: {},
  legend: { left: 'center' },
  // legend: { left: 'center', bottom: 20 },
  grid: {
    left: '3%',
    right: '14%',
    bottom: '3%',
    //bottom: '50',
    containLabel: true,
  },
  xAxis: {
    data: [],
    name: '(ปี)',
    axisLine: { onZero: true },
    splitLine: { show: false },
    splitArea: { show: false },
    boundaryGap: [0, 0.01],
  },
  yAxis: { name: '(ล้านบาท)' },
  grid: {
    bottom: 100,
  },
  series: [],
}
